function TeamController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function initTeamItemDetail(){
		var items = $('.team-item', _this.container);
		
		$.fn.matchHeight._maintainScroll = true;
		$('.box-content', items).matchHeight({ property: 'min-height' });
		
		// hide more-link for empty items
		items.each(function(index) {
			var item = $(this);
			if(!checkHasContent(item)) {
				$('.more', item).hide();
			}
		});
		
		// more-link handler
		$('a.more', items).click(function(e) {
			e.preventDefault();
			var link = $(this);
			var item = link.closest('.team-item');
			var textBox = $('.text', item);
			item.toggleClass('expanded');
			$.fn.matchHeight._update();
			
			if(item.hasClass('expanded')){
				link.text(link.data('labelLess'));
				/*
				// scroll on expand only
				setTimeout(function(){
					NavigationUtils.scrollToElement(textBox, getHeaderScrollOffset());
				}, 100);
				*/
			} else {
				link.text(link.data('labelMore'));
			}
		});
	}
	
	
	/*
	 * Check if there is enough text to show More/Less button
	 */
	function checkHasContent(textBox){
		var length = String($('.item-content', textBox).text()).trim().length;
		if(length > 0){
			return true;
		}
		return false;
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			
			// init
			initTeamItemDetail();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
